"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchResultsTable = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var typeography_common_1 = require("../typeography/typeography.common");
function HighlightStartText(_a) {
    var children = _a.children, highlight = _a.highlight;
    if (!highlight)
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    var lowerText = children.toLowerCase();
    var lowerHighlight = highlight.toLowerCase();
    if (!lowerText.startsWith(lowerHighlight))
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("b", null, children.substring(0, highlight.length)),
        children.substring(highlight.length)));
}
function UserSearchResultsTable(_a) {
    var headerText = _a.headerText, countText = _a.countText, emptyText = _a.emptyText, boldPhrase = _a.boldPhrase, users = _a.users, onSelectUser = _a.onSelectUser, sx = _a.sx;
    return (react_1.default.createElement(material_1.Box, { className: "user-search-results-list", sx: __assign({ display: 'flex', flexDirection: 'column', gap: '.5rem' }, sx) },
        (headerText || countText) && (react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            } },
            headerText && react_1.default.createElement(typeography_common_1.ILH3, null, headerText),
            countText && (react_1.default.createElement(typeography_common_1.ILH4, { sx: { color: 'text.secondary' } }, ((users === null || users === void 0 ? void 0 : users.length) || 0) + ' ' + countText)))),
        (!users || !(users === null || users === void 0 ? void 0 : users.length)) && (react_1.default.createElement(typeography_common_1.ILBody1, { sx: {
                width: 1,
                textAlign: 'center',
            } }, emptyText)),
        users && (users === null || users === void 0 ? void 0 : users.length) !== 0 && (react_1.default.createElement(material_1.TableContainer, null,
            react_1.default.createElement(material_1.Table, null,
                react_1.default.createElement(material_1.TableHead, null,
                    react_1.default.createElement(material_1.TableRow, null,
                        react_1.default.createElement(material_1.TableCell, null, "First Name"),
                        react_1.default.createElement(material_1.TableCell, null, "Last Name"),
                        react_1.default.createElement(material_1.TableCell, null, "Email"),
                        react_1.default.createElement(material_1.TableCell, { align: "right" }, "Shopify Id"))),
                react_1.default.createElement(material_1.TableBody, null, users === null || users === void 0 ? void 0 : users.map(function (user) {
                    var _a;
                    return (react_1.default.createElement(react_1.default.Fragment, { key: user.guid },
                        react_1.default.createElement(material_1.TableRow, { onClick: function () { return onSelectUser(user); }, "aria-label": "menuitem ".concat(user.firstName, " ").concat(user.lastName), sx: {
                                '&:hover': {
                                    background: 'background.default',
                                },
                            } },
                            react_1.default.createElement(material_1.TableCell, null,
                                react_1.default.createElement(HighlightStartText, { highlight: boldPhrase }, user.firstName)),
                            react_1.default.createElement(material_1.TableCell, null,
                                react_1.default.createElement(HighlightStartText, { highlight: boldPhrase }, user.lastName)),
                            react_1.default.createElement(material_1.TableCell, null,
                                react_1.default.createElement(HighlightStartText, { highlight: boldPhrase }, user.email)),
                            react_1.default.createElement(material_1.TableCell, { align: "right", title: user.shopifyId ? 'Shopify Id' : 'User Id' },
                                react_1.default.createElement(HighlightStartText, { highlight: boldPhrase }, (_a = user.shopifyId) !== null && _a !== void 0 ? _a : user.guid)))));
                })))))));
}
exports.UserSearchResultsTable = UserSearchResultsTable;
